import { actions } from '../actions';
import { reduxSwitch } from '../../../tools';

const defaultState = {
	preview: null,
	list: null,
	uri: null,
	parameters: null,
	hasMore: null,
	pending: false,
	error: null,
	at: null,
	// export
	exporting: false,
	progress: null, // { percent, done, total }
	csv: null,
};

const updateAnchor = (parameters, summaries) => {
	if (summaries && summaries.length > 0) {
		let summary = summaries[summaries.length-1];
		let anchorAt = parameters.timeRange.retrospective
			? summary.trip.startAt
			: summary.trip.endAt
		;
		parameters.timeRange.window.anchorAt = anchorAt;
	}
	return parameters;
}

function apiReducer(state, action) {
	let _state;
	switch (action.type) {
		case actions.trip.request.type:
			if (action.clear) {
				_state = { ...defaultState };
			} else {
				_state = {...state};
			}
			return {
				..._state,
				uri: action.uri,
				parameters: action.parameters,
				pending: true,
				error: null,
				at: action.clear ? new Date() : _state.at
			};
		case actions.trip.success.type:
			const summaries = action.report && action.report.summaries;
			const batchSize = state.parameters.timeRange.window.size;
			const hasMore = summaries ? summaries.length == batchSize : false;
			const list = state.list ? (summaries ? state.list.concat(summaries) : state.list) : (summaries ? [...summaries] : []);;
			_state = {...state};
			return {
				..._state,
				list,
				parameters: updateAnchor(state.parameters, summaries),
				hasMore,
				pending: false
			};
		case actions.trip.fail.type:
			return {
				...state,
				pending: false,
				error: action.errorMessage
			};
		case actions.trip.cancel.type:
			return {
				...state,
				pending: false
			};
		default:
			return state;
	}
}

function exportReducer(state, action) {
	switch (action.type) {
		case actions.trip.export.type:
			return {
				...state,
				exporting: true,
				progress: null,
				csv: null
			}
		case actions.trip.exportProgress.type:
			return {
				...state,
				progress: {
					percent: action.progress,
					done: action.count,
					total: action.total
				}
			}
		case actions.trip.exportDone.type:
			return {
				...state,
				parameters: state.parameters,
				exporting: false,
				csv: action.csv
			}
		case actions.trip.exportClear.type:
			return {
				...state,
				csv: null
			}
		default:
			return state;
	}

}

const reducer = reduxSwitch([apiReducer, exportReducer], defaultState);

export { reducer };
